module.exports = __webpack_public_path__ + "img/check-cirlce.beace736.svg";